module.exports = __webpack_public_path__ + "static/media/NotoSansThai-Regular.68cede96.ttf";